<template>
  <div id="app">
    <com-page2 v-if="page==2" :info="info" @go="handleChou"></com-page2>
    <com-page3 v-else-if="page==3||page==4" :info="info" :isnew="isNew" @open="handleOpenApp"></com-page3>
    <!-- <com-page4 v-else-if="page==4" :info="info" @open="handleOpenApp"></com-page4> -->
    <com-page1 v-else :info="info" @go="handleHelp"></com-page1>
    <com-heng v-if="isHeng"></com-heng>
    <span id="copyText"
      data-clipboard-action="copy"
      :data-clipboard-text="copyText"
      @click="copyLink"
    ></span>
    <van-overlay :show="wechat" @click="setWechat(false)">
      <div class="wechat">
        <img src="./assets/img/weixin.png" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import comPage1 from '@/components/page1'
import comPage2 from '@/components/page2'
import comPage3 from '@/components/page3'
// import comPage4 from '@/components/page4'
import comHeng from '@/components/heng'

import ClipboardJs from 'clipboard'
import { mapState, mapMutations } from 'vuex'

import { GetRequestParam } from '@/utils/browser'
import { getStorage, setToStorage, isAlready, checkIcon, openApp, setDate, dateAlready } from '@/utils/index'
import { b64Decode, getCopyText } from '@/utils/base64'
import request from '@/utils/request'
import md5 from 'js-md5'
import qs from 'qs'
import behavior from '@/utils/behavior'

export default {
  name: 'App',
  data() {
    return {
      page: 1,
      copyText: '',
      helper: {},
      isHeng: false,
      helpData: null,
      isDateAlready: false,
      isNew: true,
      sdkReady: false,
      sdkNeed: false
    }
  },
  computed: {
    ...mapState(['wechat', 'info']),
    sdk() {
      return this.sdkReady && this.sdkNeed
    }
  },
  created() {
    // id=3&acc=王国&icon=1&picon=url&shoeid=1001&progress=9819
    // const test = { id: 3, acc: 'BOB141353553', icon: '2', picon: '', shoeid: 1006, progress: 9819 }
    // console.log(b64Encode(test))
    this.b = decodeURIComponent(GetRequestParam('b'))

    // 获取微信SDK的签名等信息
    this.getWechatSdkCode()

    const obj = getStorage()
    const objInfo = isAlready(obj)
    if (!obj || !objInfo) {
      this.getInfo()
      this.sendMsg()
      this.sendHelp()
      return
    }
    this.setInfo(objInfo)
    this.sendMsg()
    // this.sendHelp()
    if (objInfo && objInfo.page) {
      this.isNew = parseInt(objInfo.page) !== 4
      this.page = objInfo.page
    }
  },
  mounted() {
    const mql = window.matchMedia('(orientation: portrait)')
    this.handleOrientationChange(mql)
    mql.addListener(this.handleOrientationChange)

    const height = document.documentElement.clientHeight
    document.getElementById('app').style.height = height + 'px'

    window.addEventListener('load', () => {
      this.sdkReady = true
      console.log('load')
    })
  },
  methods: {
    ...mapMutations(['setWechat', 'setInfo']),
    handleOrientationChange(mql) {
      this.isHeng = !mql.matches
    },
    // 解析链接的参数，获取信息
    getInfo() {
      try {
        const info = b64Decode(this.b)
        info.avatar = checkIcon(info.picon, info.icon)
        this.setInfo(info)
      } catch (e) {
        this.setInfo({})
        this.$toast.fail('参数错误')
      }
    },
    getSendData(type) {
      let time = new Date().getTime()
      time = Math.floor(time / 1000)
      // 536+d33615aa0235481214f80c3c3e1ff60b+1595318722+BOB30000536
      // const signStr = `${this.info.id}+d33615aa0235481214f80c3c3e1ff60b+${time}+` + encodeURIComponent(this.info.acc)
      const signStr = `${this.info.id}+d33615aa0235481214f80c3c3e1ff60b+${time}+${type}`
      const data = {
        str: this.b,
        tm: time,
        sign: md5(signStr),
        type: type
      }
      return qs.stringify(data)
    },
    sendMsg() {
      const body = this.getSendData('pageshow')
      request.post('/api/battleofballs/action/sneakers', body)
    },
    async sendHelp() {
      this.isDateAlready = dateAlready()
      if (this.isDateAlready) {
        this.helpData = { Id: 0, Account: '', Icon: 0, PassIcon: '', ShoeId: 0, Process: 0, ShareProg: 0, Type: 0 }
      } else {
        try {
          const body = this.getSendData('speedup')
          this.helpData = await request.post('/api/battleofballs/action/sneakers', body)
          this.sdkNeed = true
        } catch (e) {
          this.helpData = { Id: 0, Account: '', Icon: 0, PassIcon: '', ShoeId: 0, Process: 0, ShareProg: 0, Type: 0 }
        }
        setDate()
      }
    },
    // 第1页：帮他加速
    async handleHelp() {
      // let res = {}
      // if (dateAlready()) {
      //   behavior('帮TA加速', '新点击')
      //   res = { Id: 0, Account: '', Icon: 0, PassIcon: '', ShoeId: 0, Process: 0, ShareProg: 0, Type: 0 }
      // } else {
      //   behavior('帮TA加速', '点击')
      //   const body = this.getSendData('speedup')
      //   // const body = qs.stringify({ uid: this.info.id })
      //   res = await request.post('/api/battleofballs/action/sneakers', body)
      //   setDate()
      //   // { "Id": 536, "Account": "BOB30000536", "Icon": 3, "PassIcon": "", "ShoeId": 21, "Process": 93, "ShareProg": 0, "Type": 1 }
      //   // A分享给B
      //   // ShareProg: 加速者进度，也就是B的进度（eg: 9990）   Process：分享者当前进度，也就是A的进度
      // }
      // 改成一打开链接，就去请求数据
      if (!this.helpData) {
        await this.sendHelp()
      }
      const res = this.helpData
      let info = null
      // Type 0未抽奖  1已经抽奖
      // if (res && parseInt(res.Type) === 1) {
      //   // 已经抽奖
      //   this.page = 4
      //   info = Object.assign({}, this.info, {
      //     page: this.page,
      //     progress: res.Process,
      //     helperProgress: res.ShareProg,
      //     helperShoeId: res.ShoeId
      //   })
      //   // 复制内容到剪切板
      //   this.handleCopy(res.ShoeId)
      // } else {
      // 未抽奖
      this.page = 2
      this.isNew = parseInt(res.Type) !== 1
      this.isDateAlready
        ? behavior('帮TA加速', '新点击')
        : behavior('帮TA加速', '点击')
      info = Object.assign({}, this.info, {
        page: this.page,
        progress: res.Process
      })
      // }
      this.setInfo(info)
      setToStorage(info)
      // 复制内容到剪切板
      this.handleCopy()
    },
    // 第2页：试试运气
    handleChou(shoeId) {
      behavior('试试运气', '点击')
      this.page = 3
      const info = Object.assign({}, this.info, {
        page: 3,
        helperProgress: 0,
        helperShoeId: shoeId
      })
      this.setInfo(info)
      setToStorage(info)
      // 复制内容到剪切板
      this.handleCopy(shoeId)
    },
    // 第3、4页：打开球球大作战
    handleOpenApp(shoeId, size) {
      const info = Object.assign({}, this.info)
      size && (info.helperSize = size)
      this.setInfo(info)
      setToStorage(info)
      // 复制内容到剪切板
      this.handleCopy(shoeId, size)
      this.$nextTick(() => {
        openApp()
      })
    },
    handleCopy(shoeId, size) {
      // u: id
      // e: 鞋子
      // s：尺码
      const data = { u: this.info.id }
      shoeId && (data.e = shoeId)
      data.s = 0
      size && (data.s = size)

      this.copyText = getCopyText(data)
      this.$nextTick(() => {
        document.getElementById('copyText').click()
        // if (document.all) { // ie浏览器
        //   document.getElementById('copyText').click()
        // } else { // 其它浏览器
        //   const e = document.createEvent('MouseEvents')
        //   e.initEvent('click', true, true)
        //   document.getElementById('copyText').dispatchEvent(e)
        // }
      })
    },
    copyLink() {
      const clipboard = new ClipboardJs('#copyText')
      clipboard.on('success', function(e) {
        // console.info('Action:', e.action)
        // console.info('Text:', e.text)
        // console.info('Trigger:', e.trigger)
        // e.clearSelection()
      })
      clipboard.on('error', function(e) {
        // console.error('Action:', e.action)
        // console.error('Trigger:', e.trigger)
      })
    },
    async getWechatSdkCode() {
      if (process.env.VUE_APP_MODE !== 'prod' || !window.wx) {
        return
      }
      const sandKey = '-0]$l\\E^32#]~,E%co"SJ96jf(0%JI-qQ[*1]=!@#96*a'
      const body = qs.stringify({
        token: window.hex_md5(sandKey),
        url: window.location.href
      })
      const res = await request.post('/api/wechatqiuqiu/js-dy-index/get-js-package', body)
      const wx = window.wx
      wx.config({
        debug: false,
        appId: res.appid, // 必填，公众号的唯一标识
        timestamp: res.timestamp, // 必填，生成签名的整数型时间戳不加引号
        nonceStr: res.nonceStr, // 必填，生成签名的随机串
        signature: res.signature, // 必填，签名
        jsApiList: [
          'hideMenuItems'
        ]
      })
      wx.ready(function() {
        wx.checkJsApi({
          jsApiList: [
            'hideMenuItems'
          ],
          success: function(res) { }
        })
        wx.hideMenuItems({
          menuList: [
            'menuItem:share:appMessage',
            'menuItem:share:timeline',
            'menuItem:copyUrl',
            'menuItem:share:qq',
            'menuItem:share:weiboApp',
            'menuItem:favorite',
            'menuItem:share:facebook',
            'menuItem:share:QZone',
            'menuItem:editTag',
            'menuItem:delete',
            'menuItem:copyUrl',
            'menuItem:originPage',
            'menuItem:readMode',
            'menuItem:openWithQQBrowser',
            'menuItem:openWithSafari',
            'menuItem:share:email',
            'menuItem:share:brand',
            'menuItem:setFont',
            'menuItem:exposeArticle'
          ]
        })
      })
    }
  },
  watch: {
    sdk(newVal) {
      newVal && behavior('助力', '发送')
    }
  },
  components: {
    comPage1,
    comPage2,
    comPage3,
    // comPage4,
    comHeng
  }
}
</script>
